import { useState } from 'react';
import { useInit } from '../../../../Contexts/InitProvider';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField from '../../../../utils/InputField';
import { ApiUpdateStepsConfig } from '../BasicOperation';

function ServiceActivityConfigModal({ closeModal }) {
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);

    const { initInfo, initStateUpdated } = useInit();

    const { initiate, implement, ongoing, done } = initInfo.steps;

    const [formData, setFormData] = useState({
        Initiate: initiate,
        Implement: implement,
        Ongoing: ongoing,
        Done: done
    });
    const { setMessage } = useTemplate();

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSaveClick = (e) => {
        e?.preventDefault();
        const payload = {
            Initiate: formData?.Initiate,
            Implement: formData?.Implement,
            Ongoing: formData?.Ongoing,
            Done: formData.Done
        };
        setLoading(true);
        ApiUpdateStepsConfig(payload, setIsError)
            .then(({ title }) => {
                closeModal();
                initStateUpdated();
                setMessage({ type: 'success', text: title });
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString() });
            });
    };
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSaveClick}>
            <div className="flex flex-col gap-y-3 mb-5">
                <InputField
                    label="Initiate"
                    name="Initiate"
                    placeholder="Type..."
                    formData={formData}
                    onChange={handleChange}
                />

                <InputField
                    label="Implement"
                    name="Implement"
                    placeholder="Type..."
                    formData={formData}
                    onChange={handleChange}
                />

                <InputField
                    label="Ongoing"
                    name="Ongoing"
                    placeholder="Type..."
                    formData={formData}
                    onChange={handleChange}
                />

                <InputField
                    label="Done"
                    name="Done"
                    placeholder="Type..."
                    formData={formData}
                    onChange={handleChange}
                />
            </div>

            <div className="flex justify-end">
                <div className="flex items-center gap-x-3">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary title="Save" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default ServiceActivityConfigModal;
